import { useSerialStore } from '@/state/serialStore';
import { HELPER_RECONNECT_INTERVAL_MS } from '@skyrover/shared/constants';
import { useEffect } from 'react';

/** Poll helper status; refresh COM ports only on startup and plug/unplug events. */
export function useSerialBootstrap(): void {
  const initialize = useSerialStore((state) => state.initialize);
  const refreshPorts = useSerialStore((state) => state.refreshPorts);
  const refreshHelperStatus = useSerialStore((state) => state.refreshHelperStatus);

  useEffect(() => {
    initialize();

    const pollTimer = window.setInterval(() => {
      void refreshHelperStatus();
    }, HELPER_RECONNECT_INTERVAL_MS);

    if (typeof navigator === 'undefined' || !navigator.serial) {
      return () => {
        window.clearInterval(pollTimer);
      };
    }

    const handleDeviceConnect = () => {
      void refreshPorts();
    };

    const handleDeviceDisconnect = () => {
      const { connected, disconnect } = useSerialStore.getState();
      if (connected) {
        void disconnect({ unexpected: true });
        return;
      }
      void refreshPorts();
    };

    navigator.serial.addEventListener('connect', handleDeviceConnect);
    navigator.serial.addEventListener('disconnect', handleDeviceDisconnect);

    return () => {
      window.clearInterval(pollTimer);
      navigator.serial?.removeEventListener('connect', handleDeviceConnect);
      navigator.serial?.removeEventListener('disconnect', handleDeviceDisconnect);
    };
  }, [initialize, refreshHelperStatus, refreshPorts]);
}
